import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import { deleteMapById } from '~workspace/api/deleteMapById'
import { searchMapsByWorkspaceId } from '~workspace/api/searchMapsByWorkspaceId'

export const mapInitialState = {
  loading: false,
  deleting: false,
  maps: [],
  total: 0
}

export const searchMapsByWorkspaceIdQuery = createAsyncThunk(
  'maps/searchMapsByWorkspaceIdQuery',
  async (args) => {
    const { items, total } = await searchMapsByWorkspaceId(args)
    return { total, items }
  }
)

export const deleteMapByIdMutation = createAsyncThunk(
  'maps/deleteMapByIdMutation',
  async ({ byId }) => {
    await deleteMapById(byId)
    return { mapId: byId }
  }
)

export const mapListSlice = createSlice({
  name: 'maps',
  initialState: mapInitialState,
  reducers: {
    setMaps: (state, action) => {
      state.maps = action.payload
      state.loading = false
    },
    setTotal: (state, action) => {
      state.total = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchMapsByWorkspaceIdQuery.pending, (state) => {
        state.loading = true
      })
      .addCase(searchMapsByWorkspaceIdQuery.fulfilled, (state, action) => {
        const { items, total } = action.payload
        state.loading = false
        state.maps = items
        state.total = total
      })
      .addCase(searchMapsByWorkspaceIdQuery.rejected, (state) => {
        state.loading = false
      })

    builder
      .addCase(deleteMapByIdMutation.pending, (state) => {
        state.deleting = true
      })
      .addCase(deleteMapByIdMutation.fulfilled, (state, action) => {
        const { mapId } = action.payload
        const maps = current(state.maps)

        state.deleting = false
        state.maps = maps.filter((map) => map.id !== mapId)
        state.total = maps.length - 1
      })
      .addCase(deleteMapByIdMutation.rejected, (state) => {
        state.deleting = false
      })
  }
})

export const { setMaps, setTotal, setMapDeleting, setMapLoading } =
  mapListSlice.actions

export const useMaps = () => useSelector((state) => state.maps.maps)
export const useMapsLoading = () => useSelector((state) => state.maps.loading)
export const useMapsTotal = () => useSelector((state) => state.maps.total)
export const useMapsDeleting = () => useSelector((state) => state.maps.deleting)

export default mapListSlice.reducer
